import React from "react";
import { Helmet } from "react-helmet";
import {
  Header,
  Titulo,
  ContenedorHeader,
  ContenedorBotones
} from "./elementos/Header";
import Boton from "./elementos/Boton";
import BotonCerrarSesion from "./elementos/BotonCerrarSesion";
import FormularioGasto from './componentes/FormularioGasto';
import BarraTotalGastado from './componentes/BarraTotalGastado';
//extraer el usuario logeado
import { useAuth } from "./contextos/AuthContext";

const App = () => {
  //contextos/AuthContext - useAuth()
  const { usuario } = useAuth();
  return (
    <>
      <Helmet>
        <title>Agregar Gasto</title>
      </Helmet>

      <Header>
      
        <ContenedorHeader>
          <Titulo>Agregar Gasto</Titulo>
          <ContenedorBotones>
            <Boton>{usuario.email}</Boton>
            <Boton to="/categorias">Categorías</Boton>
            <Boton to="/lista">Gastos</Boton>
            <BotonCerrarSesion />
          </ContenedorBotones>
        </ContenedorHeader>
      </Header>

      <FormularioGasto />

      <BarraTotalGastado />
    </>
  );
};

export default App;
